import React from "react";
import {
  Box,
  Typography,
  IconButton,
  // Menu,
  // MenuItem,
  // Divider,
} from "@mui/material";
import {
  Folder,
  MoreVert,
  // Share,
  // MoveToInbox,
  // Download,
  // OpenInBrowser,
  // ArrowForward,
  // Edit,
  // NotInterested,
} from "@mui/icons-material";
import { useTheme } from "../style/theme";
// import ItemMorevertMenu from "./ItemMorevertMenu.jsx";
import { useUser } from "../hooks/Authorize";
import { getFileIconAndColor, useSortedItems } from "./utils";
import Sorters from "./Sorters.jsx";

const Catelog = ({ title = '', handleMoreVertMenuOpen, items, setClikkleItems,
  selectedSort, setSelectedSort, isDescending, setIsDescending, handleFolderNavigationClick, showTitle = true, showLocation = false, handleRowClick
}) => {
  // console.log('catelog items = ', items)
  const platformUser = JSON.parse(localStorage.getItem("user"));

  // const [anchorEl, setAnchorEl] = useState(null);
  // const [currentMenuClickedItem, setCurrentMenuClickedItem] = useState({});


  const { mode } = useTheme();

  var sortedItems = useSortedItems(items, selectedSort, isDescending, platformUser._id)

  sortedItems = [...sortedItems]
    .filter(item => {
      // Check for uniqueness by _id AND (name + folderPath)
      const isUniqueById = items.findIndex(i => i._id === item._id) === items.indexOf(item);
      const isUniqueByNameAndPath = items.findIndex(i =>
        i.name === item.name &&
        i.folderPath === item.folderPath
      ) === items.indexOf(item);

      return isUniqueById && isUniqueByNameAndPath && item.type === "folder";

    })
  // const handleMoreVertMenuOpen = (event, item) => {
  //   setAnchorEl(event.currentTarget);
  //   // setAnchorElSubMenu(null);
  //   // setSubmenuOpen(false); // Close submenu on menu close

  //   setCurrentMenuClickedItem(item);
  //   console.log("Menu opened: ", item)
  // };




  return (
    <>
      {/* <ItemMorevertMenu
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        currentMenuClickedItem={currentMenuClickedItem}
        item={currentMenuClickedItem}
        setClikkleItems={setClikkleItems}
        items={items}
      /> */}


      {showTitle && title && items.length > 0 &&
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="body" fontFamily="sans-serif" fontWeight="700">
            {title}
          </Typography>
          <Sorters
            selectedSort={selectedSort}
            onSortChange={setSelectedSort}
            isDescending={isDescending}
            onDirectionChange={setIsDescending}
          />
        </Box>
      }

      <Box
        display="grid"
        // gridTemplateColumns="repeat(auto-fit, minmax(15rem, 1fr))"
        // gridTemplateColumns="repeat(auto-fill, minmax(15rem, max-content))"
        sx={{
          gridTemplateColumns: `repeat(auto-fill, minmax(15rem, 1fr))`,

        }}

        gap="1rem"
        // padding="0.5rem"
        paddingTop={2}
        paddingBottom={2}
        width={"100%"}
      >
        {sortedItems?.map((item, index) => (
          <Box
            padding="1rem"
            key={index}
            display="flex"
            alignItems="center"
            justifyContent={"space-between"}
            sx={{
              backgroundColor: mode === "light" ? "white" : "",
              border: `1px solid ${mode === "light" ? "#e5e7eb" : "rgba(31, 31, 31, 1)"}`,
              width: "255px",
              height: "60px",
              borderRadius: "0.5rem",
              marginX: "2px",
              ":hover": {
                backgroundColor: mode === "light" ? "#f7f7f7" : "#2E2E2E",
              },
            }}
          >
            <Box
              width="100%"
              display="flex"
              gap="1rem"
              alignItems="center"  // This vertically centers all items
              justifyContent="space-between"
            >
              <Box
                onClick={(e) => {
                  e.stopPropagation();
                  handleRowClick(item);
                }}
                display="flex"
                gap="1rem"
                width="100%"
                alignItems="center"  // Add this to center items vertically within this box
              >
                <Box
                  display="flex"
                  alignItems="center"  // Center the icon vertically
                  justifyContent="center"  // Center the icon horizontally
                  minWidth={30}  // Give a fixed width to the icon container
                >
                  {item.clikkle ? (
                    <Folder style={{ fontSize: "1.5rem", color: "#488BF1" }} />
                  ) : (
                    <></>
                  )}
                  {!item.clikkle && item.type === "folder" && (() => {
                    const { icon } = getFileIconAndColor({
                      type: item.type,
                      extension: item.type === "file" ? item.name.split(".").pop().toLowerCase() : "",
                      isShortcut: item.isShortcut,
                      overrideColor: item.color,
                      fontSize: 30,
                      mode: mode,
                    })
                      ;
                    return icon;
                  })()}

                  {/* {item.type === "file" && (() => {
                    const { icon } = getFileIconAndColor({
                        type: item.type,
                        extension: item.type === "file" ? item.name.split(".").pop().toLowerCase() : "",
                        isShortcut: item.isShortcut,
                      })
                      ;
                    return icon;
                  })()} */}
                </Box>

                <Box
                  display="flex"
                  flexDirection="column"
                  justifyContent="center"  // Center the text vertically
                  flexGrow={1}  // Allow this to take remaining space
                >
                  <Typography
                    onDoubleClick={() => handleFolderNavigationClick(item)}
                    fontFamily="sans-serif"
                    fontWeight="500"
                    whiteSpace="nowrap"
                    textOverflow="ellipsis"
                    overflow="hidden"
                    sx={{
                      color: mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#fff",
                      lineHeight: "normal"  // Ensure consistent line height
                    }}
                    fontSize="13px"
                  >
                    {item.name.length > 12 ? `${item.name.substring(0, 12)}...` : item.name}


                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "11px",
                      color: mode === "light" ? "rgba(0, 0, 0, 0.6)" : "#777",
                      marginTop: 0.6


                    }}
                  >
                    {
                      showLocation && <>
                        {item.ownerId === platformUser._id ? "In My Files" : "In Shared With Me"}
                      </>
                    }
                  </Typography>
                </Box>
              </Box>

              <Box display="flex" alignItems="center">
                <IconButton
                  onClick={(e) => handleMoreVertMenuOpen(e, item)}
                  sx={{ color: "#A5A5A5" }}
                >
                  <MoreVert style={{ fontSize: 24 }} />
                </IconButton>
              </Box>
            </Box>
          </Box>
        ))}



      </Box></>
  );
};

export default Catelog;
